export const FACEBOOK_GET_CONFIG = 'shopgate.facebook.getConfig';
